module.exports = __webpack_public_path__ + "img/25_48.10005c82.png";